import React, { useState } from 'react';
import { Input } from 'antd';
import classnames from 'classnames';
import './TextBox.scss';
import { ReactComponent as EyeClosed } from 'style/icons/visibility-outline.svg';
import { ReactComponent as EyeOpen } from 'style/icons/visibility-filled.svg';
import { ReactComponent as ErrorLogo } from 'style/_assets/icons/error.svg';
import Label from 'components/form/Label/Label';
import InputMask from 'react-input-mask';
import { phoneNumberMask } from 'helpers/phone.helper';
import { formatTextWithRegexToLowerCase } from 'helpers/string.helper';

const VariableInput = function ({
  type,
  datatestid,
  placeholder,
  disabled,
  showPassword,
  isPasswordInput,
  onFocused,
  onBlurred,
  inputRef,
  mask,
  ...props
}) {
  if (type === 'phoneNumber') {
    return (
      <InputMask
        mask={phoneNumberMask}
        alwaysShowMask={true}
        data-testid={datatestid ? `${datatestid}-TextBox` : null}
        placeholder={placeholder}
        disabled={disabled}
        {...props}
      >
        {inputProps => <Input {...inputProps} />}
      </InputMask>
    );
  }
  if (type === 'shortDate') {
    return (
      <InputMask
        mask="99/99/99"
        alwaysShowMask={true}
        data-testid={datatestid ? `${datatestid}-TextBox` : null}
        placeholder={placeholder}
        disabled={disabled}
        {...props}
      >
        {inputProps => <Input {...inputProps} />}
      </InputMask>
    );
  }
  if (!showPassword && isPasswordInput) {
    return (
      <Input
        ref={inputRef}
        type={type}
        data-testid={datatestid ? `${datatestid}-TextBox` : null}
        placeholder={placeholder}
        disabled={disabled}
        {...props}
      />
    );
  }
  return (
    <Input
      data-testid={datatestid ? `${datatestid}-TextBox` : null}
      placeholder={placeholder}
      disabled={disabled}
      {...props}
    />
  );
};

const ShowEye = function () {
  return (
    <div tabIndex={'0'} role="button">
      <EyeOpen data-testid="passwordShowEye" role="img" aria-label="EyeOpen" />
    </div>
  );
};

const HideEye = function () {
  return (
    <div tabIndex={'0'} role="button">
      <EyeClosed
        data-testid="passwordShowEye"
        role="img"
        aria-label="EyeClosed"
      />
    </div>
  );
};

export function BottomError({ error }) {
  return (
    error &&
    typeof error === 'string' &&
    error.length && (
      <div className="bottomError margT4">
        <div>
          <ErrorLogo aria-label="ErrorLogo" />
        </div>
        <Label type="caption" className="errorText" role={'alert'}>
          {error}
        </Label>
      </div>
    )
  );
}

function TextBox({
  datatestid,
  placeholder,
  disabled,
  type,
  error,
  colorType,
  outerClassName,
  hideTopPlaceholder,
  inputRef,
  fullWidth,
  ariaLabel,
  'aria-label': labelAria,
  ...props
}) {
  const ref = inputRef ? inputRef : React.createRef();

  const finalIsValidated = error ? error : false;
  const [showPassword, setShowPassword] = useState(false);
  const isPasswordInput = type === 'password';
  const toggleShowHidePassword = function () {
    setShowPassword(!showPassword);
  };
  let floatingLabelClass = 'text-box floating-label';
  if (outerClassName) floatingLabelClass += ` ${outerClassName} `;
  if (disabled) {
    floatingLabelClass = floatingLabelClass.concat(' disabled');
  }
  if (finalIsValidated) {
    floatingLabelClass = floatingLabelClass.concat(' error');
  }
  if (colorType === 'black') {
    floatingLabelClass = floatingLabelClass.concat(' blackLabel');
  }
  if (hideTopPlaceholder) {
    floatingLabelClass = floatingLabelClass.concat(' noTopPlaceholder');
  }

  const fullWidthClass = fullWidth ? 'fullWidth' : '';
  const forLabel = formatTextWithRegexToLowerCase(placeholder);

  return (
    <>
      <div className={classnames(floatingLabelClass, fullWidthClass)}>
        <VariableInput
          inputRef={ref}
          type={type}
          data-testid={datatestid ? `${datatestid}-TextBox` : null}
          placeholder={placeholder}
          disabled={disabled}
          showPassword={showPassword}
          isPasswordInput
          autoComplete="off"
          {...props}
          id={forLabel}
        />
        {!hideTopPlaceholder && <label for={forLabel}>{placeholder}</label>}
        {isPasswordInput && (
          <div
            onClick={toggleShowHidePassword}
            className="showHideEye"
            data-testid="showHideEyeClick"
            onKeyPress={toggleShowHidePassword}
          >
            {showPassword ? <ShowEye /> : <HideEye />}
          </div>
        )}
      </div>
      {finalIsValidated ? <BottomError error={error} /> : null}
    </>
  );
}

export { TextBox };
